export default {
    last_interaction_ticket: 'Comentó en el ticket ',
}
